module.exports = __webpack_public_path__ + "static/assets/d7eefc8ff5cad20411e4df2c85825c62.png";